<template>
  <div>
  <v-card max-width="600">
    <v-app-bar color="accent" dark rounded flat>
      <v-toolbar-title>{{job.jobName}}を実施した記録をする</v-toolbar-title>
    </v-app-bar>
    <v-card-text>
      <v-form ref="record_form">
        <v-row>
          <v-col cols="12" sm="6">
            <v-select
              v-model="evaluation"
              :items="evaluations"
              item-text="label"
              item-value="value"
              label="自己評価"
              required
              :rules="[rules.required]"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-textarea 
              v-model="impresstion" 
              label="所感" 
              required
              :counter="50"
              :rules="[rules.required, rules.max50]"></v-textarea>
          </v-col>
        </v-row>
        <div class="text-right">
          <v-btn color="secondary" @click="$emit('close')" outlined class="ml-2">閉じる</v-btn>
          <v-btn color="accent" @click="post" class="ml-2">投稿</v-btn>
        </div>
      </v-form>
    </v-card-text>  
  </v-card>
  <success-modal-component :job="job" :message="message" :subMessage="subMessage"></success-modal-component>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SuccessModalComponent from '@/components/SuccessModal.vue';
import moment from "moment";
  export default {
    components: {
      SuccessModalComponent
    },
    props: ["job"],
    data() {
      return {
        evaluations: [
        { label: 'すごくできた' , value: 4   },
        { label: 'できた' , value: 3   },
        { label: '少しできた' , value: 2    },
        { label: 'あまりできなかった'   , value: 1  },
        ],
        impresstion: '',
        evaluation: null,
        rules: {
          required: v => !!v || '必須',
          max50: v => (v || '').length <= 50 || '最大50文字'
        },
        today: moment().format('YYYY-MM-DD'),
        powerPerJob: 10,
        powerPerGroupJob: 5,
        message: '',
        subMessage: ''
      }
    },
    computed: {
      // 個人ジョブかグループジョブかの判定
      isGroup(){
        return this.job.groupId
      },
      // ユーザーのジョブ継続回数
      userJobContinueCount(){
        const memberList = this.job.memberList;
        const usersJob = memberList.find(member => member.userId === this.loginUserId);
        return usersJob.jobContinueCount;
      },
      // 全体のジョブ継続回数
      jobContinueCount() {
        return this.job.memberList.reduce((prev, current) => prev + current.jobContinueCount, 0)
      },
      // ジョブを達成した場合の経験値
      powerByAchieve(){
        const job = this.job
        return !job.groupId ? this.powerPerJob * job.jobTargetContinueCount : this.powerPerGroupJob * job.jobTargetTotalCount
      },
      ...mapGetters(['loginUserId', 'loginUserInfo']),
    },
    methods:{
      post(){
        if(this.$refs.record_form.validate()){
          const job = this.job
          const userInfo = this.loginUserInfo;
          // ユーザーのジョブ継続回数を加算する
          const userJobContinueCount = this.userJobContinueCount + 1;
          this.addUserJobContinueCount(userJobContinueCount);
          // ジョブを達成したかどうかを判定する
          const isAchieve = this.checkIsAchive(userJobContinueCount);
          // ユーザーの経験値を計算する
          userInfo.userAchievementPower = this.calcAchievementPower(isAchieve);
          // ジョブの実施日を更新する（個人ジョブのみ）
          if(!this.isGroup) job.scheduledDate[this.today] = true
          // ジョブのステータスを更新する（達成時のみ）
          if(isAchieve) job.jobStatus = 2
          const recordContent = `${userJobContinueCount}回目の「${job.jobName}」を実施！
                                  経験値は${userInfo.userAchievementPower}ポイントになりました！`
          const record = {
            recordAt: new Date(),
            recordEvaluation: this.evaluation,
            recordImpresstion: this.impresstion,
            recordContent: recordContent,
            userId: this.loginUserId,
            jobId: this.job.jobId,
            groupId: this.job.groupId
          }
          this["job/recordJob"]({record: record, job: job, userJobContinueCount: userJobContinueCount, userInfo: userInfo})
          // ジョブを達成した場合は追加のレコード作成
          if(isAchieve){
            const recordContent = `ついに「${job.jobName}」をクリアしました！`
            const record = {
              recordAt: new Date(),
              recordEvaluation: this.evaluation,
              recordImpresstion: this.impresstion,
              recordContent: recordContent,
              userId: this.loginUserId,
              jobId: this.job.jobId,
              groupId: this.job.groupId
            }
            this['record/createRecord'](record);
          }
          // ジョブ実施時のメッセージを作成する
          this.createDoneMessage(isAchieve, userJobContinueCount, userInfo.userAchievementPower);
          this.$emit('close')
          this.impresstion = ''
          this.evaluation = null
          this.$refs.record_form.resetValidation();
          this.toggleSuccessModal();
        }
      },
      addUserJobContinueCount(userJobContinueCount){
        const memberList = this.job.memberList;
        const Index = memberList.findIndex(member => member.userId === this.loginUserId);
        memberList[Index].jobContinueCount = userJobContinueCount;
      },
      checkIsAchive(userJobContinueCount){
        return !this.isGroup ? userJobContinueCount == this.job.jobTargetContinueCount
                             : this.jobContinueCount == this.job.jobTargetTotalCount
      },
      calcAchievementPower(isAchieve){
        const basePower = !this.isGroup ? this.powerPerJob : this.powerPerGroupJob;
        const currentAchievementPower = this.loginUserInfo.userAchievementPower;
        const jobTargetContinueCount = this.job.jobTargetContinueCount;
        let achievementPower = 0;
        if(isAchieve){
          if(!this.isGroup){
            achievementPower = currentAchievementPower + basePower * jobTargetContinueCount
          } else{
            achievementPower = 100; //TODO ロジックを追記
          }
        } else{
            achievementPower = currentAchievementPower + basePower
        }
        return achievementPower;
      },
      createDoneMessage(isAchieve, userJobContinueCount, userAchievementPower){
        if(isAchieve){
          this.message = '目標達成！'
          this.subMessage = '目標回数をクリア！おめでとうございます！'
        } else{
          this.message = 'ジョブ実施！'
          this.subMessage = `${userJobContinueCount}回目のジョブ達成です！達成力が${userAchievementPower}ポイントになりました！`
        }
      },
      ...mapActions(['job/recordJob', 'toggleSuccessModal', 'record/createRecord'])
    }
  }
</script>
